import createIcon from '../../createIcon';

/**
 * @component @name AutoDelete
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMkgxMS41TDEwLjUgMUg1LjVMNC41IDJIMVY0SDE1VjJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTYgOUMxNS4zIDkgMTQuNjMgOS4xIDE0IDkuMjlWNUgyVjE3QzIgMTguMSAyLjkgMTkgNCAxOUg5LjY4QzEwLjggMjEuMzYgMTMuMjEgMjMgMTYgMjNDMTkuODcgMjMgMjMgMTkuODcgMjMgMTZDMjMgMTIuMTMgMTkuODcgOSAxNiA5Wk0xNiAyMUMxMy4yNCAyMSAxMSAxOC43NiAxMSAxNkMxMSAxMy4yNCAxMy4yNCAxMSAxNiAxMUMxOC43NiAxMSAyMSAxMy4yNCAyMSAxNkMyMSAxOC43NiAxOC43NiAyMSAxNiAyMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNi41IDEySDE1VjE3TDE4LjYgMTkuMUwxOS40IDE3LjlMMTYuNSAxNi4yVjEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AutoDelete = createIcon('AutoDelete', [
  ['path', { d: 'M15 2H11.5L10.5 1H5.5L4.5 2H1V4H15V2Z', key: '123u36' }],
  [
    'path',
    {
      d: 'M16 9C15.3 9 14.63 9.1 14 9.29V5H2V17C2 18.1 2.9 19 4 19H9.68C10.8 21.36 13.21 23 16 23C19.87 23 23 19.87 23 16C23 12.13 19.87 9 16 9ZM16 21C13.24 21 11 18.76 11 16C11 13.24 13.24 11 16 11C18.76 11 21 13.24 21 16C21 18.76 18.76 21 16 21Z',
      key: '5z8kts',
    },
  ],
  ['path', { d: 'M16.5 12H15V17L18.6 19.1L19.4 17.9L16.5 16.2V12Z', key: '1kcknd' }],
]);

export default AutoDelete;
